<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      title         = "Lotto"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                <!-- DROPDOWN -->
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown>

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import firebase from 'firebase/app';
import 'firebase/database';
import BackToTop           from 'vue-backtotop'
import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu
  },
  data() {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems      : navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
    },
    navMenuItems: {
      immediate: true,
      handler(value) {
          for(const x in value){
            for(const xx in value[x].items){
              /*if(value[x].items[xx].icon !== undefined && value[x].items[xx].icon == "UserIcon"){
                value[x].items[xx].tag =3;
                value[x].items[xx].tagColor ='success';
              }*/
              if(value[x].items[xx].role !== undefined && (value[x].items[xx].role !== this.activeUserInfo.role)) {
                value[x].items.splice(xx, 1);
              }
            }
          }
      }
    }
  },
  computed: {
    statement(){
      return this.$store.state.statementManagement.statement
    },
    withdraw(){
      return this.$store.state.historyManagement.withdraw
    },
    deposit(){
      return this.$store.state.historyManagement.deposit
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  },
  async created() {
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    const created = firebase.database().ref('huay/1').orderByChild('datetime').limitToLast(1);
    created.on("child_changed", snapshot => {
      if(snapshot.val().six)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    const created2 = firebase.database().ref('huay/2').orderByChild('datetime').limitToLast(1);
    created2.on("child_changed", snapshot => {
      if(snapshot.val().five)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    const created3 = firebase.database().ref('huay/3').orderByChild('datetime').limitToLast(1);
    created3.on("child_changed", snapshot => {
      if(snapshot.val().five || snapshot.val().five2)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    const created4 = firebase.database().ref('huay/4').orderByChild('datetime').limitToLast(1);
    created4.on("child_changed", snapshot => {
      if(snapshot.val().five)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    const created5 = firebase.database().ref('huay/5').orderByChild('datetime').limitToLast(1);
    created5.on("child_changed", snapshot => {
      if(snapshot.val().five)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    const created6 = firebase.database().ref('huay/6').orderByChild('datetime').limitToLast(1);
    created6.on("child_changed", snapshot => {
      if(snapshot.val().five)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    const created15 = firebase.database().ref('huay/15').orderByChild('datetime').limitToLast(1);
    created15.on("child_changed", snapshot => {
      if(snapshot.val().five)
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    // created.on("child_added", (snapshot) => {
    //   if(snapshot.val().createdate){
    //   const createdate = snapshot.val().createdate.split(' ');
    //   const time = createdate[1].split(':');
    //   const date = createdate[0]+' '+time[0]+':'+time[1];
    //   if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //     const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/newuser.mp3');
    //     audio.play();
    //     this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) });
    //   }
    //   }
    // });

    // const created2 = firebase.database().ref('rewards');
    // created2.on("child_changed", snapshot => {
    //   this.$store.dispatch('userManagement/updateRewards',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    // });
    // created2.on("child_added", (snapshot) => {
    //   if(snapshot.val().createdate){
    //     const createdate = snapshot.val().createdate.split(' ');
    //     const time = createdate[1].split(':');
    //     const date = createdate[0]+' '+time[0]+':'+time[1];
    //     if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //       this.$store.dispatch('userManagement/fetchRewards').catch(err => { console.error(err) });
    //     }
    //   }
    // });

    // const created3 = firebase.database().ref('redeems');
    // created3.on("child_changed", snapshot => {
    //   this.$store.dispatch('userManagement/updateRedeems',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    // });
    // created3.on("child_added", (snapshot) => {
    //   if(snapshot.val().createdate){
    //     const createdate = snapshot.val().createdate.split(' ');
    //     const time = createdate[1].split(':');
    //     const date = createdate[0]+' '+time[0]+':'+time[1];
    //     if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //       this.$store.dispatch('userManagement/fetchRedeems').catch(err => { console.error(err) });
    //     }
    //   }
    // });
    // //deposit
    // const _users = (await firebase.database().ref(`/users`).once('value')).val();
    // const users = [];
    // for(const x in _users){
    //   users[_users[x].userId] = _users[x];
    // }
    // let deposits = (this.deposit.length>0)?this.deposit:[];
    // firebase.firestore().collection("history").where("type", "==", "ฝาก").orderBy('createdate','desc').limit(500)
    // .onSnapshot(async (snapshot) => {
    //      const data = [];
    //     snapshot.docChanges().forEach((change) => {
    //       data[change.doc.id] = change.doc.data();
    //       data[change.doc.id].typedata = change.type;
    //       data[change.doc.id].qty = Number(change.doc.data().qty.toString().replace(/,/g,''));
    //     });
    //     for(const x in data){
    //       if (data[x].typedata === "added") {
    //         const deposit = data[x];
    //         if(!users[deposit.userId]){
    //             const _users = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(deposit.userId).once('value')).val();
    //             let user = [];
    //             for(const x in _users){
    //               user = _users[x];
    //               user.key = x;
    //             }
    //             users[deposit.userId] = user;
    //         }
    //         if(users[deposit.userId] && users[deposit.userId].code){
    //           const createdate = deposit.createdate.split(' ');
    //           const time = createdate[1].split(':');
    //           const date = createdate[0]+' '+time[0]+':'+time[1];
    //           if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //             const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/deposit.mp3');
    //             audio.play();
    //           }
    //           const user = users[deposit.userId];
    //           deposit.key = x;
    //           deposit.linename = user.linename;
    //           deposit.firstname = user.firstname;
    //           deposit.lastname = user.lastname;
    //           deposit.bank = user.bank;
    //           deposit.account_no = user.account_no;
    //           deposit.code = user.code;
    //           deposit.pictureUrl = user.pictureUrl;
    //           deposits.push(deposit);
    //         }
    //       }
    //       if (data[x].typedata === "modified") {
    //           const value = data[x];
    //           const keyUser = _.findKey(deposits, function(o) { return o.key === x; });
    //           if(keyUser){
    //             const deposit =  deposits[keyUser];
    //             deposit.qty = Number(value.qty.toString().replace(/,/g,''));
    //             deposit.status = value.status;
    //             deposit.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //             deposits.splice(keyUser, 1);
    //             deposit.key = x;
    //             deposits.splice(keyUser, 0, deposit);
    //           }
    //       }
    //     }
    //     if(deposits.length > 0){
    //       deposits = _.orderBy(deposits, ['createdate'],['desc']);
    //       this.$store.commit('historyManagement/SET_DEPOSIT', deposits);
    //     }
    // });

    // //withdraw
    // let withdraws = (this.withdraw.length>0)?this.withdraw:[];
    // firebase.firestore().collection("history").where("type", "==", "ถอน").orderBy('createdate','desc').limit(500)
    // .onSnapshot(async (snapshot) => {
    //     const data = [];
    //     snapshot.docChanges().forEach((change) => {
    //       data[change.doc.id] = change.doc.data();
    //       data[change.doc.id].typedata = change.type;
    //       data[change.doc.id].qty = Number(change.doc.data().qty.toString().replace(/,/g,''));
    //     });
    //     for(const x in data){
    //       if (data[x].typedata === "added") {
    //         const withdraw = data[x];
    //         const createdate = withdraw.createdate.split(' ');
    //         const time = createdate[1].split(':');
    //         const date = createdate[0]+' '+time[0]+':'+time[1];
    //         if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //           const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/withdraw.mp3');
    //           audio.play();
    //         }
    //         if(!users[withdraw.userId]){
    //             const _users = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(withdraw.userId).once('value')).val();
    //             let user = [];
    //             for(const x in _users){
    //               user = _users[x];
    //               user.key = x;
    //             }
    //             users[withdraw.userId] = user;
    //         }
    //         if(users[withdraw.userId] && users[withdraw.userId].code){
    //           const user = users[withdraw.userId];
    //           withdraw.key = x;
    //           withdraw.linename = user.linename;
    //           withdraw.firstname = user.firstname;
    //           withdraw.lastname = user.lastname;
    //           withdraw.bank = user.bank;
    //           withdraw.account_no = user.account_no;
    //           withdraw.code = user.code;
    //           withdraw.pictureUrl = user.pictureUrl;
    //           withdraws.push(withdraw);
    //         }
    //       }
    //       if (data[x].typedata === "modified") {
    //           const value = data[x]
    //           const keyUser = _.findKey(withdraws, function(o) { return o.key === x; });
    //           if(keyUser){
    //             const withdraw =  withdraws[keyUser];
    //             withdraw.qty = Number(value.qty.toString().replace(/,/g,''));
    //             withdraw.status = value.status;
    //             withdraw.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //             withdraws.splice(keyUser, 1);
    //             withdraw.key = x;
    //             withdraws.splice(keyUser, 0, withdraw);
    //           }
    //       }
    //     }
    //     if(withdraws.length > 0){
    //       withdraws = _.orderBy(withdraws, ['createdate'],['desc']);
    //       this.$store.commit('historyManagement/SET_WITHDRAW', withdraws);
    //     }
    // });

    // //statement
    // let statements = (this.statement.length>0)?this.statement:[];
    // firebase.firestore().collection("krungsri").where("type", "==", "ฝาก").orderBy('date','desc').limit(500)
    // .onSnapshot(async (snapshot) => {
    //     const data = [];
    //     snapshot.docChanges().forEach((change) => {
    //       data[change.doc.id] = change.doc.data();
    //       data[change.doc.id].typedata = change.type;
    //       data[change.doc.id].qty = Number(change.doc.data().qty.toString().replace(/,/g,''));
    //     });
    //     for(const x in data){
    //       if (data[x].typedata === "added") {
    //         const statement = data[x];
    //        // console.log(statement);
    //         if(statement.createdate){
    //           const createdate = statement.createdate.split(' ');
    //           const time = createdate[1].split(':');
    //           const date = createdate[0]+' '+time[0]+':'+time[1];
    //           if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //             const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/statement.mp3');
    //             audio.play();
    //             setTimeout(() => {
    //               audio.play();
    //             }, 1000);
    //           }
    //         }
    //         if(!users[statement.userId] && statement.userId){
    //             const _users = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(statement.userId).once('value')).val();
    //             let user = [];
    //             for(const x in _users){
    //               user = _users[x];
    //               user.key = x;
    //             }
    //             users[statement.userId] = user;
    //         }
    //         if(users[statement.userId] && users[statement.userId].code){
    //           const user = users[statement.userId];
    //           statement.key = x;
    //           statement.linename = user.linename;
    //           statement.firstname = user.firstname;
    //           statement.lastname = user.lastname;
    //           statement.bank = user.bank;
    //           statement.account_no = user.account_no;
    //           statement.code = user.code;
    //           statement.pictureUrl = user.pictureUrl;
    //           statement.createdate = statement.date;
    //           statements.push(statement);
    //         }else{
    //           if(statement.truewallet && statement.detail){
    //             statement.firstname = statement.detail;
    //           }else{
    //             statement.firstname = '';
    //           }
    //           statement.key = x;
    //           statement.linename = '';
              
    //           statement.lastname = '';
    //           statement.account_no = statement.bank;
    //           statement.bank = '';
    //           statement.code = '';
    //           statement.pictureUrl = '';
    //           statement.createdate = statement.date;
    //           statements.push(statement);
    //         }
    //       }
    //       if (data[x].typedata === "modified") {
    //           const value = data[x];
    //           const keyUser = _.findKey(statements, function(o) { return o.key === x; });
    //           if(keyUser){
    //             const statement =  statements[keyUser];
    //             statement.qty = Number(value.qty.toString().replace(/,/g,''));
    //             statement.status = value.status;
    //             statement.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //             statement.createdate = value.date;
    //             statements.splice(keyUser, 1);
    //             statement.key = x;
    //             statements.splice(keyUser, 0, statement);
    //           }
    //       }
    //     }
    //     if(statements.length > 0){
    //       statements = _.orderBy(statements, ['createdate'],['desc']);
    //       this.$store.commit('statementManagement/SET_STATEMENT', statements);//commit('SET_STATEMENT', statements);
    //     }
    // });
    //https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/coins.mp3
  }
}

</script>

